import React from "react";
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const networktopologies = require("../../../assets/icons-pack/5.1 Virtual Private Cloud/ic_01_networktopologies.svg");
const hybridcloud = require("../../../assets/icons-pack/5.1 Virtual Private Cloud/ic_02_hybridcloud.svg");
const iaaspaas = require("../../../assets/icons-pack/5.1 Virtual Private Cloud/ic_03_iaaspaas.svg");
const trafficmonitoring = require("../../../assets/icons-pack/5.1 Virtual Private Cloud/ic_04_trafficmonitoring.svg");

const VPC = () => {
    const heading = `VIRTUAL PRIVATE CLOUD (VPC)`;
    const details = `Designed to logically isolate and secure your cloud-based infrastructure, giving you the ability to manage it just as your on-premises network.`;

    const overview = [
        `DETASAD Virtual Private Cloud (VPC) lets you provision a logically isolated section of the Cloud with enhanced security where you can launch resources in a virtual network that you define.`,
        `It ensures that you have complete control over your virtual networking environment, including creation of subnets, creation of your zones using a dedicated firewall provided for your environment, and configuration of route tables and network gateways.`
    ];

    const advantages = [
        [
            `Network Topologies`,
            `With DETASAD VPC, you can benefit from your favorite network virtual appliances such as Web Application Firewalls, WAN optimizers, Application Delivery Controllers, and NGFW available at DETASAD Market Place to define traffic flows, allowing you to architect your environment with a higher degree of control.`,
            networktopologies
        ],
        [
            `Hybrid Cloud`,
            `Leverage with DETASAD Virtual Private Cloud (VPC) to build your own hybrid cloud architecture that securely connects to your on-premises datacenter.`,
            hybridcloud
        ],
        [
            `IaaS and PaaS, A Better Combo`,
            `Combine DETASAD Platform as a service (PaaS) powered by RedHat OpenShift and Infrastructure as a service (IaaS) in a virtual network to get more flexibility, elasticity, and scalability when you’re building applications.`,
            iaaspaas
        ],
        [
            `Traffic Monitoring`,
            `Monitor and share a deep copy of your in and outbound virtual network traffic 24x7. Once subscribed and configured, administrators can create basic alerts based on various log and flow triggers using DETASAD monitoring tools.`,
            trafficmonitoring
        ]
    ];

    const functions = [
        [
            `Choose Your Own Connectivity Option`,
            [
                `A variety of connectivity options exist for your DETASAD Virtual Private Cloud (VPC). You can connect your Virtual Private Cloud (VPC) to the Internet, to your data center, or other Virtual Private Cloud (VPCs), based on the DETASAD Cloud’s resources that you want to expose publicly and those that you want to keep private.`
            ]
        ],
        [
            `Host multiple Virtual Private Clouds (VPC)`,
            [
                `DETASAD Cloud allows you to create and manage multiple Virtual Private Clouds (VPC) at any given time. A secured private connection between a VPC and your own data center using a secured VPN connection can be established as well ensuring that you have no issues in managing your cumulative resources.`
            ]
        ],
        [
            `Customized Networking`,
            [
                `For each VPC, multiple private or public subnets can be established and access to these subnets can be managed to make sure that you have control of your cloud. Elastic IPs can be created and attached to public facing instances, while protected by Anti-DDoS.`
            ]
        ]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-network"/>
            <SubNav overview={overview} advantages={advantages} functions={functions}/>
            <Footer />
        </div>
    );
};

export default VPC;
